import { IconInfoCircleFilled } from '@tabler/icons-react';
import { NSLabel, NSCellInput } from 'bricks';
import IconWithTooltip from 'components/IconWithTooltip/IconWithTooltip';

export const DEFAULT_CONSTRUCTION_COST_INFLATION_RATE = 0;

export const CONSTRUCTION_COST_INFLATION_TOOLTIP_TEXT = 'Applies to Hard Cost and Soft Cost lines, growing from start date';

export interface IConstructionCostInflationInputProps {
    value?: number | null;
    onChange: (rate: number) => void;
    disabled?: boolean;
}

/**
 * Toolbar value for the annual construction cost inflation rate applied to every
 * Hard/Soft Cost budget line on the pro forma. `value` is a decimal fraction
 * (e.g. 0.05 for 5%); `null`/`undefined` displays 0% — no rate has been set on
 * any line, so no inflation is actually being applied.
 */
const ConstructionCostInflationInput = ({ value, onChange, disabled }: IConstructionCostInflationInputProps) => (
    <div className="d-flex align-items-center">
        <NSLabel className="pl-0 my-auto mr-1 font-weight-normal text-dark text-nowrap">
            Construction cost inflation
        </NSLabel>
        <IconWithTooltip
            name="construction-cost-inflation"
            icon={IconInfoCircleFilled}
            tooltipText={CONSTRUCTION_COST_INFLATION_TOOLTIP_TEXT}
            className="mr-2"
        />
        <NSCellInput
            type="number"
            numberType="percentage"
            value={value ?? DEFAULT_CONSTRUCTION_COST_INFLATION_RATE}
            handleUpdateValue={updatedValue => onChange(Number(updatedValue))}
            placeholder="Enter percentage"
            disabled={disabled}
        />
    </div>
);

export default ConstructionCostInflationInput;
